// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/ground-handling-engine-safety.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/ground-handling-engine-safety/ground-handling-engine-safety.js';

mount([g0]);
